import React from 'react';

import voca from 'voca';

import { useFieldAttributesQuery } from 'components/hooks/fieldAttributeQueries';

import CollectionSelect from 'components/application/CollectionSelect';
import DatePickerField from 'components/application/DatePickerField';
import TextArea from 'components/application/TextArea';
import TextField from 'components/application/TextField';

import { findCurrentFieldValue } from 'components/helpers/personnel';

export default function PersonnelCustomFieldsForm({
  currentPersonnel,
  onDateFieldChange,
  onFieldOptionChange,
  onPersonnelFieldChange,
  removeErrorStyling,
  requestError,
}) {
  const {
    data: domainFieldAttributes,
    isSuccess: isDomainFieldAttributesSuccess,
  } = useFieldAttributesQuery();

  return (
    isDomainFieldAttributesSuccess &&
    domainFieldAttributes.data.map((fieldAttribute) => {
      const {
        attributes: { formattedFieldType, name },
        id: fieldAttributeId,
      } = fieldAttribute;

      const fieldProps = {
        key: fieldAttributeId,
        label: name,
        name: fieldAttributeId,
        onChange: onPersonnelFieldChange,
        value:
          findCurrentFieldValue({
            fieldAttribute,
            fieldOptions: domainFieldAttributes.included.fieldOption,
            fieldValues: currentPersonnel.fieldValues,
          }) || '',
      };

      switch (formattedFieldType) {
        case 'singleLineText':
          return <TextField {...fieldProps} />;
        case 'multiLineText':
          return <TextArea {...fieldProps} />;
        case 'email':
          return (
            <TextField
              {...fieldProps}
              fieldError={requestError.validationErrors[voca.camelCase(name)]}
              removeErrorStyling={() => {
                removeErrorStyling({ target: { name: voca.camelCase(name) } });
              }}
            />
          );
        case 'date':
          return (
            <DatePickerField
              {...fieldProps}
              onChange={onDateFieldChange}
              value={currentPersonnel.fieldValues[fieldAttribute.id]?.value}
            />
          );
        case 'select': {
          const options = fieldAttribute.relationships.fieldOptions.data.map(
            (fieldOption) => ({
              label:
                domainFieldAttributes.included.fieldOption[fieldOption.id]
                  .attributes.value,
              value: { optionId: fieldOption.id },
            }),
          );

          const currentFieldOptionId =
            currentPersonnel.fieldValues[fieldAttribute.id]?.fieldOptionId;

          return (
            <CollectionSelect
              {...fieldProps}
              isClearable={true}
              isSearchable={true}
              onChange={onFieldOptionChange}
              options={options}
              value={
                currentFieldOptionId &&
                options.find(
                  (option) => option.value.optionId === currentFieldOptionId,
                )
              }
            />
          );
        }
        default:
          return null;
      }
    })
  );
}
